/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logout_ButtonInputs */

const en_logout_button = /** @type {(inputs: Logout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

const fr_logout_button = /** @type {(inputs: Logout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const ms_sg2_logout_button = /** @type {(inputs: Logout_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log keluar`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Logout_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const logout_button = /** @type {((inputs?: Logout_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logout_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logout_button(inputs)
	if (locale === "fr") return fr_logout_button(inputs)
	return ms_sg2_logout_button(inputs)
});